import { DevicesActionTypes } from "./constants";

// constants

export interface DeviceActionType {
  type:
    | DevicesActionTypes.API_RESPONSE_SUCCESS
    | DevicesActionTypes.API_RESPONSE_ERROR
    | DevicesActionTypes.GET_DEVICES
    | DevicesActionTypes.UPDATE_DEVICES
    | DevicesActionTypes.DELETE_DEVICES
    | DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY
    | DevicesActionTypes.ADD_DEVICES
    | DevicesActionTypes.CLEAR_ERROR;

  payload: {} | string;
}

// common success
export const DeviceApiResponseSuccess = (actionType: string, data: any | {}): DeviceActionType => ({
  type: DevicesActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const DeviceApiResponseError = (actionType: string, error: string): DeviceActionType => ({
  type: DevicesActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// get locations
export const getDevices = (params?: { page?: number; limit?: number; type?: string; status?: string }): DeviceActionType => ({
  type: DevicesActionTypes.GET_DEVICES,
  payload: params || {},
});

export const deleteDevices = (id: string): DeviceActionType => ({
  type: DevicesActionTypes.DELETE_DEVICES,
  payload: {
    id,
  },
});

export const updateDevice = (
  id: string,
  unique_id: string,
  device_id: string,
  name: string,
  location_id: number | string | null,
  corporate_id: number | string | null,
  total_powerbanks: number,
  available_powerbanks: number,
  status: string
): DeviceActionType => ({
  type: DevicesActionTypes.UPDATE_DEVICES,
  payload: { id, unique_id, device_id, name, location_id, corporate_id, total_powerbanks, available_powerbanks, status },
});

// add Device
export const addDevice = (
  unique_id: string,
  device_id: string,
  name: string,
  location_id: number | string | null,
  corporate_id: number | string | null,
  total_powerbanks: number,
  available_powerbanks: number
): DeviceActionType => ({
  type: DevicesActionTypes.ADD_DEVICES,
  payload: { unique_id, device_id, name, location_id, corporate_id, total_powerbanks, available_powerbanks },
});

export const updateAvailability = (id: string, available_powerbanks: number): DeviceActionType => ({
  type: DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY,
  payload: { id, available_powerbanks },
});

// clear error
export const clearDeviceError = (): DeviceActionType => ({
  type: DevicesActionTypes.CLEAR_ERROR,
  payload: {},
});
